import React from "react";
import MetaTags from "react-meta-tags";
import Subscribe from "../../component/Subscribe";
import "../../common/SCSS/newsletterStyle.css";

function NewsletterThirtyTwo() {
  return (
    <>
      <section
        className="about-banner-section"
        style={{ padding: "150px 0 62px" }}
      >
        <div className="about-circle">
          <div className="about-circle-1"></div>
          <div className="about-circle-2"></div>
          <div className="about-circle-3"></div>
          <div className="about-circle-4"></div>
          <div className="about-circle-5"></div>
        </div>
        <div className="about-banner-container">
          <div className="about-content">
            <h1 className="about-title" style={{ paddingTop: "25px" }}>
              SustainabilityConnect
            </h1>
            <p
              className="about-description"
              style={{ fontSize: "25px", marginTop: "18px", marginBottom: "0" }}
            >
              Newsletter May 2025
            </p>
          </div>
        </div>
        <div className="about-elements">
          <div className="about-element-1"></div>
          <div className="about-element-2"></div>
          <div className="about-element-3"></div>
          <div className="about-element-4"></div>
          <div className="about-element-5"></div>
        </div>
      </section>
      <div className="newsletter-container">
        <MetaTags>
          <title>
            New York enforces strict emissions reporting requirements for
            high-emitting sectors.
          </title>
          <meta
            name="description"
            content="New York State has introduced draft regulations requiring large greenhouse gas (GHG) emitters to report their annual emissions, marking a major step under the Climate Leadership and Community Protection Act."
          />
          <meta
            property="og:title"
            content="UpdaptCSR | Sustainability Platform"
          />
        </MetaTags>

        <div
          className="Newsletter-title1"
          style={{ paddingTop: "56px", fontSize: "32px" }}
        >
          New York enforces strict emissions reporting requirements for
          high-emitting sectors.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/images/may_2025_1.webp")}
            alt="new york"
            loading="lazy"
          />
        </figure>
        <p>
          New York State has introduced draft regulations requiring large
          greenhouse gas (GHG) emitters to report their annual emissions,
          marking a major step under the Climate Leadership and Community
          Protection Act. The proposed rules target sectors such as power
          generation, manufacturing, transportation, and waste management,
          focusing on entities exceeding set emissions thresholds. Companies
          will need to submit detailed data on carbon dioxide, methane, nitrous
          oxide, and fluorinated gases, ensuring the information is accurate and
          independently verified.
        </p>
        <p>
          The regulations demand businesses establish strong internal data
          systems, apply rigorous measurement and reporting standards, and
          secure third-party verification. Organizations must cover both Scope 1
          (direct) and Scope 2 (indirect) emissions and prepare for the likely
          expansion into Scope 3 (supply chain) reporting. These steps are
          critical for compliance and for aligning with broader national and
          international climate commitments.
        </p>
        <p>
          Checklist for companies to prepare:
          <ul>
            <li>Assess current emissions sources and profiles.</li>
            <li>
              Upgrade or install reliable data collection and tracking systems.
            </li>
            <li>Engage third-party verifiers to review emissions data.</li>
            <li>
              Align internal reporting practices with state and international
              standards.
            </li>
            <li>
              Train internal teams on compliance requirements and audit
              readiness.
            </li>
          </ul>
        </p>
        <p>
          Failure to comply could expose companies to regulatory penalties,
          reputational damage, and competitive disadvantages. As New York
          tightens its climate accountability framework, businesses must act
          proactively to meet evolving expectations, safeguard operations, and
          maintain stakeholder trust.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            Mandatory GHG reporting will drive businesses to refine supply
            chains, adopt energy-efficient technologies, and enhance climate
            risk management. This fosters resilience, sharpens competitive
            positioning, and unlocks access to ESG-focused capital. Firms that
            adapt early can shape market standards, strengthening brand trust
            and securing long-term profitability in a low-carbon economy.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          Philippine Government Launches Comprehensive Sustainable Finance
          Strategy.
        </div>
        <div className="Newsletter-picture">
          <figure style={{ marginTop: "25px" }}>
            <img
              className="picture"
              src={require("../../../../../assets/images/may_2025_2.webp")}
              alt="Philippine"
              loading="lazy"
            />
          </figure>
        </div>
        <p>
          The Philippine Department of Finance (DOF) has outlined its
          sustainable finance strategy for 2025, aiming to align financial
          policies with the country’s climate goals and strengthen green
          investment. The DOF plans to include the Bureau of the Treasury,
          Philippine Guarantee Corporation (PHILGUARANTEE), and other government
          agencies to broaden the Inter-Agency Technical Working Group on
          Sustainable Finance (ITSF) membership and take a more comprehensive
          approach to sustainable finance policies. This expansion is intended
          to improve coordination in mobilizing capital for renewable energy,
          climate adaptation, and green infrastructure projects.
        </p>
        <p>
          The ITSF will establish three key clusters: Policy, Financing, and
          Investment. Each cluster will provide focused guidance in its area
          under the Sustainable Finance Roadmap. This structured approach
          supports the integration of international best practices, the ASEAN
          sustainable finance taxonomy, and efforts to strengthen regulatory
          frameworks and increase the issuance of green and sustainable
          financial instruments.
        </p>
        <p>
          Additionally, a Center of Excellence for Sustainable Finance will be
          set up as a central hub for capacity building, policy support, and
          market development. This center will help develop expertise and
          facilitate knowledge sharing in the sustainable finance sector. As
          climate risks increase across Southeast Asia, the Philippines’
          approach reinforces its commitment to building a resilient and
          low-carbon economy.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            Companies can leverage this shift by aligning their financial
            practices with the national sustainable finance roadmap, integrating
            ESG factors into risk assessments, and preparing for evolving
            disclosure requirements. To stay ready, firms should invest in ESG
            data systems, strengthen climate risk governance, and position
            themselves to access green capital markets as regulatory
            expectations tighten and market incentives sharpen.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          China Issues $825 Million Green Bond on London Stock Exchange for
          Climate Projects.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/images/may_2025_3.webp")}
            alt="China"
            loading="lazy"
          />
        </figure>
        <p>
          China has issued a 6 billion yuan ($825 million) green bond on the
          London Stock Exchange to raise international capital for domestic
          climate initiatives. The bond is split into three-year and five-year
          maturities with interest rates of 1.88% and 1.93%. Proceeds will go to
          projects such as electric vehicle charging networks, biodiversity
          protection, and pollution control, all aligned with China’s goal of
          achieving carbon neutrality by 2060.
        </p>
        <p>
          This marks China’s entry into the $3 trillion global green bond
          market. In 2023 alone, China issued over $150 billion in green bonds,
          reflecting its expanding role in sustainable finance. The funds from
          this issuance will support five main areas: climate change mitigation,
          climate adaptation, resource conservation, pollution prevention, and
          biodiversity. By tapping global capital markets, China strengthens its
          financial backing for its transition to a low-carbon economy.
        </p>
        <p>
          The issuance also has broader economic goals. By using yuan and
          listing in London, China aims to promote its currency on the
          international stage and build stronger financial ties with the United
          Kingdom. This move aligns with China’s long-term plan to integrate ESG
          principles into its economic development.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            The issuance of China’s green bond on the global stage creates
            pressure for Chinese organisations to elevate ESG integration well
            beyond surface-level compliance. As access to international capital
            increasingly depends on measurable sustainability outcomes,
            companies will be pushed to rethink governance structures, embed
            climate risk deeply into strategic decisions, and align capital
            allocation with long-term resilience goals. This signals a shift
            where sustainability is no longer a reporting exercise but a
            structural requirement for competitiveness in both domestic and
            global markets.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          UK Introduces Integrity Principles to Strengthen Voluntary Carbon
          Markets.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/images/may_2025_4.webp")}
            alt="UK"
            loading="lazy"
          />
        </figure>
        <p>
          The UK government has launched a new framework aimed at strengthening
          the voluntary carbon and nature markets, addressing widespread
          concerns over credibility, transparency, and the actual climate impact
          of carbon credits. With global demand for offsets projected to rise
          sharply in coming years, governments, businesses, and investors are
          under pressure to ensure these markets deliver measurable emissions
          reductions and are not used as a loophole to delay or avoid real
          climate action. The UK’s initiative marks a clear move to set a higher
          bar for how carbon credits are issued, traded, and reported.
        </p>
        <p>
          At the center of this framework are 6 key integrity principles. These
          include prioritizing direct emissions reductions within company
          operations before using offsets, ensuring credits are backed by strong
          and independently verified standards, requiring transparent disclosure
          of credit use in corporate reports, making environmental claims that
          are accurate and evidence based, improving governance and oversight of
          crediting systems, and promoting collaboration among governments,
          standard setters, and industry players to align practices. Together,
          these pillars aim to close loopholes, reduce the risk of greenwashing,
          and guide investment toward projects that deliver real climate
          benefits.
        </p>
        <p>
          Compared to international frameworks such as the Integrity Council for
          the Voluntary Carbon Market’s Core Carbon Principles or the Voluntary
          Carbon Markets Integrity Initiative, the UK’s approach aligns closely
          in its focus on transparency, additionality, and governance. However,
          the UK principles place added emphasis on ensuring that companies do
          not treat offsets as a substitute for cutting their own emissions.
          While many global initiatives seek to harmonize standards, the UK
          framework goes further by explicitly linking credit use to broader
          national and international net zero targets.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            Companies should prepare by reassessing how carbon credits fit into
            their overall climate strategy, recognizing that the UK’s new
            principles elevate offsets from a marketing tool to a governance
            responsibility. They must strengthen internal systems for tracking,
            verifying, and transparently reporting credit use while ensuring
            these credits complement, not replace, real emissions cuts.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          Kenya Releases Green Finance Taxonomy to Strengthen Sustainable
          Finance.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/images/may_2025_5.webp")}
            alt="Kenya"
            loading="lazy"
          />
        </figure>

        <p>
          Kenya has launched its Green Finance Taxonomy (KGFT) and Climate Risk
          Disclosure Framework to provide the financial sector with a clear
          system for identifying and classifying green economic activities. The
          taxonomy is part of Kenya’s commitment to meet its Nationally
          Determined Contributions (NDCs) under the Paris Agreement, targeting a
          32% reduction in greenhouse gas emissions by 2030. With climate change
          expected to reduce Kenya’s GDP by up to 7.25% by 2050 if unaddressed,
          the KGFT offers banks and investors a structured approach to align
          financial activities with climate mitigation and adaptation goals.
        </p>
        <p>
          The KGFT draws from international frameworks, including the EU and
          South African taxonomies, but has been adapted to reflect Kenya’s
          specific national climate policies and economic priorities. It sets
          out environmental objectives, technical screening criteria, and
          minimum social safeguards, helping institutions track taxonomy-aligned
          activities, investments, and portfolios. The accompanying Climate Risk
          Disclosure Framework standardizes how banks report climate-related
          risks, improving consistency, comparability, and investor confidence.
        </p>
        <p>
          This initiative supports Kenya’s goal to mobilize both domestic and
          international climate finance, complementing the USD 62 billion
          estimated cost of implementing its climate actions. By introducing
          clear definitions and disclosure standards, Kenya aims to reduce the
          cost and complexity of green finance, enhance transparency, and
          strengthen the resilience of its financial system against climate
          risks.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            TTo prepare for Kenya’s Green Finance Taxonomy, banks and financial
            institutions must map their lending, investment, and portfolio
            activities against the taxonomy’s technical screening criteria and
            minimum social safeguards. This requires robust internal data
            systems to track financed emissions, energy exposures, and
            adaptation impacts at the asset and portfolio level. Institutions
            should integrate taxonomy alignment checks into credit and
            investment assessments, with board-level oversight ensuring climate
            risk disclosures meet new regulatory standards.
          </p>
        </div>
      </div>
      <Subscribe />
    </>
  );
}

export default NewsletterThirtyTwo;
